module.exports = __webpack_public_path__ + "img/1-5.cbdce1d1.png";